/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoGauge{
        restrict = "E";

        scope = {
            totalValue: "=",
            currentValue: "="
        };

        template = `<svg style="width:100%; height:100%; background-color:transparent;" xmlns="http://www.w3.org/2000/svg">
                        <rect class="meevo-gauge-outer-rect" width="0" height="28" x="2" y="2" rx="15" ry="15" fill="#424242" stroke="#D9D9D9" stroke-width="3" />
                        <rect class="meevo-gauge-inner-rect" width="0" height="16" x="9" y="8" rx="8" ry="8" fill="#ffffff" />
                    </svg>`;

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {

            var svgContainer = element.find('svg');
            var outerRect = svgContainer.find('rect.meevo-gauge-outer-rect');
            var innerRect = svgContainer.find('rect.meevo-gauge-inner-rect');

            scope.setWidths = (containerWidth) => {
                outerRect.attr('width', containerWidth - 4);
                scope.setInnerWith(containerWidth);
            }

            scope.setInnerWith = (containerWidth) => {
                if (Number.isFinite(scope.totalValue) && Number.isFinite(scope.currentValue) && scope.totalValue > 0 && scope.currentValue <= scope.totalValue) {
                    innerRect.attr('width', (containerWidth - 18) * Number(scope.currentValue) / Number(scope.totalValue));
                }
                else {
                    innerRect.attr('width', 0);
                }
            }

            var fnDeregContWidth = scope.$watch(() => svgContainer.width(), (newValue, oldValue) => {
                scope.setWidths(newValue);
            });

            var fnDeregCurrValue = scope.$watch(() => scope.currentValue, (newValue, oldValue) => {
                let containerWidth = svgContainer.width();
                scope.setInnerWith(containerWidth);
            });

            var fnDeregTotalValue = scope.$watch(() => scope.totalValue, (newValue, oldValue) => {
                let containerWidth = svgContainer.width();
                scope.setInnerWith(containerWidth);
            });

            scope.setWidths(svgContainer.width());

            element.on('$destroy', () => {
                fnDeregContWidth();
                fnDeregCurrValue();
                fnDeregTotalValue();
            });
        }

        constructor() {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoGauge();
            };

            directive.$inject = [];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoGauge", MeevoGauge.factory());
}
